import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Flex, Text } from "@chakra-ui/react";
import { TwoPanelLayout } from "../components";

const IntakeCompletePage: FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t("diagnosticDashboard.intake.intakecomplete.pageTitle");
  }, [t]);

  const leftContent = (
    <Flex direction="column" gap={4} alignItems="flex-start">
      <Text
        fontSize="44px"
        fontWeight="700"
        lineHeight="1.1"
        fontFamily="Moderat Extended Bold, sans-serif"
        color="th.black"
        maxW="464px"
      >
        {t("diagnosticDashboard.intake.intakecomplete.heading")}
      </Text>
      <Text fontSize="18px" fontWeight="400" lineHeight="1.4" color="th.black" maxW="464px">
        {t("diagnosticDashboard.intake.intakecomplete.subheading")}
      </Text>
    </Flex>
  );

  const rightContent = (
    <Flex direction="column" gap="35px" pb="120px">
      {/* SVG with clipPath definition */}
      <svg width="0" height="0" style={{ position: "absolute" }}>
        <defs>
          <clipPath id="oval" clipPathUnits="objectBoundingBox">
            <path
              d="M0.847609 0.777907C0.664096 1.00743 0.359711 1.06907 0.167745 0.91559C-0.024221 0.762107 -0.0310734 0.451618 0.15244 0.222093C0.335952 -0.00743086 0.640338 -0.0690741 0.832304 0.0844095C1.02427 0.237893 1.03112 0.548382 0.847609 0.777907Z"
              fill="white"
            />
          </clipPath>
        </defs>
      </svg>

      {/* What's next section */}
      <Text
        fontSize="28px"
        fontWeight="700"
        fontFamily="Moderat Extended Bold, sans-serif"
        lineHeight="1.2"
        color="th.black"
      >
        {t("diagnosticDashboard.intake.intakecomplete.whatsNext")}
      </Text>

      <Flex direction="column" gap="30px" width="100%">
        <Flex align="flex-start" gap={5}>
          <Flex
            align="center"
            justify="center"
            bg="th.peach1"
            color="th.black"
            fontSize="18px"
            fontWeight="700"
            fontFamily="Moderat Bold, sans-serif"
            h="48px"
            w="48px"
            flexShrink={0}
            clipPath="url(#oval)"
          >
            1
          </Flex>
          <Flex direction="column" gap="10px" maxW="395px">
            <Text fontSize="18px" fontWeight="700" color="th.black" lineHeight="1.4">
              {t("diagnosticDashboard.intake.intakecomplete.step1.title")}
            </Text>
            <Text color="th.black" fontSize="16px" fontWeight="400" lineHeight="1.4">
              {t("diagnosticDashboard.intake.intakecomplete.step1.description")}
            </Text>
          </Flex>
        </Flex>

        <Flex align="flex-start" gap={5}>
          <Flex
            align="center"
            justify="center"
            bg="th.peach1"
            color="th.black"
            fontSize="18px"
            fontWeight="700"
            fontFamily="Moderat Bold, sans-serif"
            h="48px"
            w="48px"
            flexShrink={0}
            clipPath="url(#oval)"
          >
            2
          </Flex>
          <Flex direction="column" gap="10px" maxW="395px">
            <Text fontSize="18px" fontWeight="700" color="th.black" lineHeight="1.4">
              {t("diagnosticDashboard.intake.intakecomplete.step2.title")}
            </Text>
            <Text color="th.black" fontSize="16px" fontWeight="400" lineHeight="1.4">
              {t("diagnosticDashboard.intake.intakecomplete.step2.description")}
            </Text>
          </Flex>
        </Flex>
      </Flex>

      <a href="/members/v2/dashboard" style={{ textDecoration: "none", width: "100%" }}>
        <Flex
          border="1px solid"
          borderColor="th.black"
          borderRadius="xl"
          h="52px"
          justify="center"
          align="center"
          px={6}
          py={4}
          cursor="pointer"
          _hover={{ bg: "gray.50" }}
          transition="background 0.2s"
        >
          <Text fontSize="14px" fontWeight="bold" color="th.black" lineHeight="1.4">
            {t("diagnosticDashboard.intake.intakecomplete.goToDashboard")}
          </Text>
        </Flex>
      </a>
    </Flex>
  );

  return <TwoPanelLayout leftContent={leftContent} rightContent={rightContent} />;
};

// eslint-disable-next-line import/no-default-export
export default IntakeCompletePage;
